export const buildOffersFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_id',
        label: 'Venue Name',
        type: 'checkbox',
        options: (filterOptions.venueNameOptions || []).map(o => ({
          value: String(o.value),
          label: o.label,
        })),
      },
    ],
  },
  {
    id: 'offer_details',
    label: 'Offer Details',
    filters: [
      {
        id: 'state',
        label: 'Status',
        type: 'checkbox',
        options: [
          { value: 'draft', label: 'Draft' },
          { value: 'sent', label: 'Sent' },
          { value: 'accepted', label: 'Accepted' },
          { value: 'declined', label: 'Declined' },
        ],
      },
      {
        id: 'owner',
        label: 'Created By',
        type: 'checkbox',
        options: (filterOptions.ownerOptions || []).map(o => ({
          value: String(o.value),
          label: o.label,
        })),
      },
      {
        id: 'buyer',
        label: 'Buyer',
        type: 'checkbox',
        options: (filterOptions.buyerOptions || []).map(o => ({
          value: String(o.value),
          label: o.label,
        })),
      },
      {
        id: 'act_type',
        label: 'Type',
        type: 'checkbox',
        options: [
          { value: 'headline', label: 'Headliner' },
          { value: 'support', label: 'Support' },
        ],
      },
      {
        id: 'has_event',
        label: 'Event Status',
        type: 'checkbox',
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ],
      },
      {
        id: 'has_holds',
        label: 'Holds',
        type: 'checkbox',
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ],
      },
      {
        id: 'genre',
        label: 'Genre',
        type: 'checkbox',
        options: (filterOptions.genreOptions || []).map(o => ({
          value: o.value,
          label: o.label,
        })),
      },
    ],
  },
];
